// extracted by mini-css-extract-plugin
export default {"instance-form__opti-id-checkbox":"InstanceForm_instance-form__opti-id-checkbox__JmIJJ"};